import React from "react";
import TopScrollingText from "../components/TopScrollingText";
import BelowLogoScrollingText from "../components/BelowLogoScrollingText";
import Header from "../components/Header";
import ProductList from "../components/ProductList";
import Footer from "../components/Footer";
import HeroBanner from "../components/HeroBanner";
import Testimonials from "../components/Testimonials";
// import InstagramFeed from "../components/InstagramFeed";
import CategoryList from "../components/CategoryList";
import TotalOrders from "../components/TotalOrders";
import { FaWhatsapp } from "react-icons/fa";
export default function HomePage() {
    return (
        <div className="page-container">
            <TopScrollingText />
            <Header />
            <BelowLogoScrollingText />
            <HeroBanner />
            <CategoryList />
            <div className="content-wrapper">
                {/* <ProductList /> */}
                <div className="info-container">
                    <div className="info-card highlight">
                        <h3>📏 Size Note</h3>
                        <p>Prefer one size extra. Slight variation of <strong>± 0.5 to 1 inch</strong> may occur during cutting & stitching.</p>
                    </div>
                    <div className="info-card">
                        <h3>🚚 Delivery</h3>
                        <p><strong>Tamil Nadu:</strong> 24 – 48 hours</p>
                        <p><strong>Other States:</strong> 7 – 8 days</p>
                    </div>
                    <div className="info-card">
                        <h3>📦 Order Policy</h3>
                        <p>Minimum order: <strong>2 pieces (You can mix any Pattern / Models)</strong></p>
                        <p>360° opening video is mandatory for any complaints.</p>
                    </div>
                    <div className="info-card contact">
                        <h3>📞 Customer Care</h3>
                        <p>+91 9360990836</p>
                    </div>
                </div>
                <Testimonials />
            </div>
            <TotalOrders />
            <Footer />
            <a href="https://wa.me/919360990836" target="_blank" rel="noopener noreferrer" className="whatsapp-float"><FaWhatsapp size={28} /></a>
        </div>
    );
}